import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { BusinessUnitCreateFooterProps } from "models/propTypes/businessUnitPropTypes";
//#endregion
//#region components
import { WizardFooter } from "components/common";
//#endregion

const BusinessUnitCreateFooter: React.FC<BusinessUnitCreateFooterProps> = (props) => {
  const { submitForm, isFormValid, onSubmitSuccess } = props;

  return (
    <WizardFooter
      actions={[
        {
          text: TranslationKeys.BusinessUnit.SaveBusinessUnit,
          type: StyleEnums.DisplayType.Success,
          successMessage: TranslationKeys.BusinessUnit.CreatedMessage,
          onClick: submitForm,
          isDisabled: !isFormValid,
          onActionSuccess: onSubmitSuccess,
        },
      ]}
    />
  );
};

export default BusinessUnitCreateFooter;
